import { useState } from 'react';
import { useAutoPlanningMhd } from '../../../hooks/useAutoPlanningMhd';
import { useSelector } from 'react-redux';
import { stageSelector } from '../../../store/reducers/stageSlice/stageSlice';

export const useHeader = () => {
    const { settings } = useSelector((state) => state.gantReducer);

    const stages = useSelector(stageSelector.selectAll);
    const [isShowPopup, setIsShowPopup] = useState(false);
    const [isShowModal, setIsShowModal] = useState(false);
    const [autOPlanningForm, setAutOPlanningForm] = useState({
        days: `${settings.daysMHD}`,
    });

    const isPlannedStages = stages.some((stage) => stage.planned.start_date);

    const { isNotMHD, autoPlanningMhd } = useAutoPlanningMhd();

    const hidePopup = () => setIsShowPopup(false);
    const hideModal = () => {
        setIsShowModal(false);
    };
    const autoPlanning = () => {
        if (isNotMHD) {
            setIsShowPopup(true);
            return;
        }
        setIsShowModal(true);
    };

    return {
        autoPlanning,
        isShowPopup,
        hidePopup,
        hideModal,
        isShowModal,
        autOPlanningForm,
        setAutOPlanningForm,
        autoPlanningMhd,
        isPlannedStages,
    };
};
